//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion

import { IMRBaseControlDirectiveController } from '../base'

export interface ButtonListOptions {
    template: string
    hint: string
    items: any[]
    selectedItem: any
    onItemClick(e, item: any, index: number): boolean,
    onItemRendered?(e)
    onInitialize?(popover: DevExpress.ui.dxPopover)
}

interface ButtonListScope extends ng.IScope {
    options: ButtonListOptions

    buttonOptions: DevExpress.ui.dxButtonOptions
    popoverOptions: DevExpress.ui.dxPopoverOptions
    listOptions: DevExpress.ui.dxListOptions
}

export class ButtonListController extends IMRBaseControlDirectiveController {
    constructor($scope: ButtonListScope, $timeout: ng.ITimeoutService) {
        super()
        
        let popover: DevExpress.ui.dxPopover = null
        let popoverVisible = false

        $scope.buttonOptions = {
            template: $scope.options.template,
            hint: $scope.options.hint,
            onClick: e => {
                popoverVisible = !popoverVisible
                if (popover) {
                    popover.option({
                        target: e.element,
                        position: 'bottom',
                    })
                    if (popoverVisible)
                        popover.show()
                    else
                        popover.hide()
                }
            }
        }

        $scope.popoverOptions = {
            width: 200,
            onInitialized: e => {
                popover = e.component
                if ($scope.options.onInitialize)
                    $scope.options.onInitialize(popover)
            },
            onShowing: e => {
                $timeout(() => {
                    const $element: JQuery = e.component.content()

                    $element
                        .css({
                            'padding': 0,
                            'text-align': 'center',
                            'border-radius': 'inherit'
                        })
                        .closest('.dx-popup-wrapper')
                        .css('z-index', 3000)
                })
            },
            onHiding: e => {
                popoverVisible = false
            }
        }

        $scope.listOptions = {
            selectionMode: 'single',
            items: $scope.options.items,
            onItemClick: e => {
                let show = $scope.options.onItemClick(e, $scope.options.items[e.itemIndex], e.itemIndex)
                if (!show) {
                    if (popover)
                        popover.hide()
                }
            }
        }

        if ($scope.options.selectedItem)
            $scope.listOptions.selectedItems = [$scope.options.selectedItem]

        if ($scope.options.onItemRendered) {
            $scope.listOptions.onItemRendered = e => {
                $scope.options.onItemRendered(e)
            }
        }
    }
}